import axios from "axios";

const nestInstance = axios.create({
    baseURL: window.location.origin,
    // timeout: 10000,
});

/**
 * fetch from origin location
 */
export function fetch_from_ns(method: string, url: string, body: object = {}) {
    if (method === "GET") {
        return nestInstance.get(url, { params: body })
    } else if (method === "POST") {
        return nestInstance.post(url, body)
    } else if (method === "PUT") {
        return nestInstance.put(url, body)
    } else if (method === "DELETE") {
        return nestInstance.delete(url, body)
    }
}

/**
 * opens popup and check to see if popup failed
 * (for safari browsers where we have async)
 * returns True if popup failed
 * @param url
 * @param w
 * @param h
 */
export function pop(url, title = "_blank", w = 1200, h = 1000) {
    const n = window.open(url,
        title,
        "width=" + w + ",height=" + h
    );
    if (n == null) {
        return true;
    }
    return false;
}
